/* eslint-disable complexity */
import { AfterViewInit, Component, OnInit } from "@angular/core";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { UserserviceService } from "@core/AuthServices/UserService/userservice.service";
import { IonicModule } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { timeout, defaultIfEmpty } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { ChatbotService } from "src/app/services/chatbot.service";
import { ClarityService } from "src/app/services/clarity.service";
declare let window;
declare let dataLayer;
const reloadTimeout = 200;
const thousand = 1000;
@Component({
  selector: "app-live-chat",
  templateUrl: "./live-chat.component.html",
  styleUrls: ["./live-chat.component.scss"],
  standalone: true,
  imports: [IonicModule],
})
export class LiveChatComponent implements OnInit, AfterViewInit {
  public userData: Data;
  public onBoardState: string;
  public pwaSegmentStatus: string;
  public userId: string;
  public syndicateLoadedData: Data;
  public ongoingSyndicate = false;
  public checkWinning = false;
  public active_jackpot = false;
  public currencySymbol: string;
  public preferredCurrency: string;
  public userBalance: Data;
  syndicateData: Data | null = null; // Assuming Data is the type of syndicateData
  userSyndicateList: Data[] = [];
  public CloseText: string;
  public selectedLanguage: string;
  widget: HTMLTextAreaElement;
  private fetchUserData: Data;
  
  constructor(
    private authService: AuthService,
    private chatService: ChatbotService,
    private router: Router,
    public translate: TranslateService,
    private userservice: UserserviceService,
    private clarityService: ClarityService
  ) {
    this.preferredCurrency = "GBP";
    this.currencySymbol = "£";
    this.clarityService.event("live_chat_opened");
    
    // Safe parsing of chatlioDetails from localStorage with error handling
    try {
      const storedData = localStorage?.getItem("chatlioDetails");
      this.fetchUserData = storedData ? JSON.parse(storedData) : {};
    } catch (error) {
      this.authService.errorHandlerLogs("Failed to parse chatlioDetails from localStorage:", error);
      // Clear corrupted data and set default
      localStorage.removeItem("chatlioDetails");
      this.fetchUserData = {};
    }

  }
  
  private setupChatlioEventListeners() {
    let agentAssigned = false;
    
    // This method has been used to chatlio intialize
    document.addEventListener(
      "chatlio.ready",
      async () => {
        try {
          // set chatlio value in local storage to not render multiple time
          localStorage.setItem("isChatlioReady", "true");
          this.widget = document.getElementById("chatlio-widget") as HTMLTextAreaElement;
          
          // DO NOT hide the widget - let it render immediately to avoid blocking LCP
          // The widget is already visible by default
          
          // Returns the current timestamp in milliseconds.
          const currentTimestamp = new Date();
          // Set the lastLiveChatTemp value in the user's details
          this.userservice.setLastLiveChatTemp(currentTimestamp);
          
          // Wait for user data to be fetched
          const chatlioData = this.fetchUserData;
          if (!chatlioData) {
            // Handle the case where chatlioData is undefined or falsy
            return;
          }
          if (window["_chatlio"] && window["_chatlio"].identify) {
            if (chatlioData?.userData) {
              //window["_chatlio"].identify(this.userId, chatlioData?.userData);
            }
            if (chatlioData.userData?.language) {
              window["_chatlio"].configure({ language: this.userData?.language });
            }
          }
        } catch (error) {
          // Gracefully handle Chatlio widget initialization errors
          this.authService.errorHandlerLogs("Chatlio widget initialization error:", error);
          return;
        }
      },
      false
    );
    
    // This method has been used to chatlio firstMessageSent
    document.addEventListener("chatlio.firstMessageSent", () => {
      try {
        this.clarityService.event("live_chat_opened");
        if (window.analytics) {
          const chatlioData = this.fetchUserData;
          if (!chatlioData) {
            // Handle the case where chatlioData is undefined or falsy
            return;
          }
          window.analytics.track("Chatbot: Escalated to Live Chat", {
            user_id: this.userId ? this.userId : "",
            user_phase: chatlioData?.onBoardState ? chatlioData?.onBoardState : "",
            user_state: chatlioData?.pwaSegmentStatus ? chatlioData?.pwaSegmentStatus : "",
            user_age: chatlioData?.userData?.Registered_Since ? chatlioData?.userData?.Registered_Since : "",
            points_balance: "",
          });
        }
        
        dataLayer?.push({
          event: "support_event",
          user_id: this.userId,
          support_name: "Live chat",
        });
      } catch (error) {
        // Gracefully handle Chatlio event tracking errors
        this.authService.errorHandlerLogs("Chatlio firstMessageSent event error:", error);
      }
    });
    
    // This method has been used to chatlio conversationEnded
    document.addEventListener("chatlio.conversationEnded", () => {
      try {
        if (window.analytics) {
          const chatlioData = this.fetchUserData;
          if (!chatlioData) {
            // Handle the case where chatlioData is undefined or falsy
            return;
          }

          window.analytics.track("Live Chat ended by user", {
            user_id: this.userId ? this.userId : "",
            user_phase: chatlioData?.onBoardState ? chatlioData?.onBoardState : "",
            user_state: chatlioData?.pwaSegmentStatus ? chatlioData?.pwaSegmentStatus : "",
            user_age: chatlioData?.userData?.Registered_Since ? chatlioData?.userData?.Registered_Since : "",
            points_balance: "",
          });
        }
      } catch (error) {
        // Gracefully handle Chatlio event tracking errors
        this.authService.errorHandlerLogs("Chatlio conversationEnded event error:", error);
      }
    });
    
    // This method has been used to chatlio offline
    document.addEventListener("chatlio.offline", () => {
      try {
        if (window.analytics) {
          const chatlioData = this.fetchUserData;
          if (!chatlioData) {
            // Handle the case where chatlioData is undefined or falsy
            return;
          }

          window.analytics.track("Live Chat ended by time out", {
            user_id: this.userId ? this.userId : "",
            user_phase: chatlioData?.onBoardState ? chatlioData?.onBoardState : "",
            user_state: chatlioData?.pwaSegmentStatus ? chatlioData?.pwaSegmentStatus : "",
            user_age: chatlioData?.userData?.Registered_Since ? chatlioData?.userData?.Registered_Since : "",
            points_balance: "",
          });
        }
      } catch (error) {
        // Gracefully handle Chatlio event tracking errors
        this.authService.errorHandlerLogs("Chatlio offline event error:", error);
      }
    });
    
    // This method has been used to chatlio messageReceived
    document.addEventListener("chatlio.messageReceived", () => {
      try {
        if (!agentAssigned) {
          agentAssigned = true;
          if (window.analytics) {
            const chatlioData = this.fetchUserData;
            if (!chatlioData) {
              // Handle the case where chatlioData is undefined or falsy
              return;
            }

            window.analytics.track("Live Chat ended by user", {
              user_id: this.userId ? this.userId : "",
              user_phase: chatlioData?.onBoardState ? chatlioData?.onBoardState : "",
              user_state: chatlioData?.pwaSegmentStatus ? chatlioData?.pwaSegmentStatus : "",
              user_age: chatlioData?.userData?.Registered_Since ? chatlioData?.userData?.Registered_Since : "",
              points_balance: "",
            });
          }
        }
      } catch (error) {
        // Gracefully handle Chatlio event tracking errors
        this.authService.errorHandlerLogs("Chatlio messageReceived event error:", error);
      }
    });
  }
  public goBack() {
    try {
      this.router.navigateByUrl("/login");
      setTimeout(() => {
        window.location.reload();
      }, thousand);
    } catch (error) {
      return error;
    }
  }

    
  public ngOnInit(): void {
     this.authService.getUid("LiveChatComponent").then((uid) => {
      this.userId = uid;
    })
    // Setup event listeners for Chatlio
    this.setupChatlioEventListeners();
    
    // Translate text for Close Button
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.translate.use(l ? l : CommonVariable?.preferredLanguage);
      },
      (err) => {
        return err;
      }
    );
    this.translate.get(["LivePage.close"])?.subscribe(
      (close: string) => {
        this.CloseText = close["LivePage.close"];
      },
      (err) => {
        return err;
      }
    );
    
    this.chatService.currentReload.subscribe((reload) => {
      if (reload) {
        // Reload the window
        setTimeout(() => {
          window.location.reload();
        }, reloadTimeout);
      }
    });
  }

  ngAfterViewInit() {
    // CRITICAL FIX: Show the widget immediately to prevent render blocking
    // Don't wait for any API calls or cloud functions to complete
    this.widget = document.getElementById("chatlio-widget") as HTMLTextAreaElement;
    
    // Show widget immediately - no more blocking!
    if (this.widget) {
      this.widget.hidden = false;
    }
    
    // reset function is used to trigger ready function if it is already triggered
    if (!localStorage.getItem("isChatlioReady") && this.userId) {
      if (window?._chatlio && window?._chatlio?.reset) {
        window?._chatlio?.reset();
      }
    }

    // Fetch user data for Chatlio in the background (completely non-blocking)
    // All API calls happen asynchronously AFTER the widget is already visible
    setTimeout(() => {
    this.chatService.getUserDataforChatlio(this.userId)?.subscribe({
      next: (data) => {
        if (data?.status === "SUCCESS") {
          // Initialize userData object if it doesn't exist
          if (!this.fetchUserData.userData) {
            this.fetchUserData.userData = {};
          }
          this.fetchUserData.userData.check_winning_count = data.check_winning_count ?? "null";
          this.fetchUserData.userData.claimref_count = data.claimref_count ?? "null";
          this.fetchUserData.userData.game_play_count = data.game_play_count ?? "null";
          this.fetchUserData.userData.last_claimref_draw_date = data.last_claimref_draw_date ?? "null";
          this.fetchUserData.userData.last_contacted_support_timestamp = data.last_contacted_support_timestamp ?? "null";
          this.fetchUserData.userData.last_game_played = data.last_game_played ?? "null";
          this.fetchUserData.userData.last_game_reissue_date = data.last_game_reissue_date ?? "null";
          this.fetchUserData.userData.login_count = data.login_count ?? "null";
          this.fetchUserData.userData.user_rank = data.user_rank ?? "null";
          const userChatlioData = this.fetchUserData?.userData;
          // Call chatliollmv2 with timeout to prevent indefinite blocking
          // This happens in the background and doesn't block widget visibility
          const cloudFunctionCall = this.authService.getV2CloudFunction("chatliollmv2", { userChatlioData });
          
           // CRITICAL FIX: Validate that we have a valid Observable before applying timeout
            // This prevents "You provided 'undefined' where a stream was expected" errors
            if (!cloudFunctionCall || typeof cloudFunctionCall.pipe !== 'function') {
              console.error('getV2CloudFunction returned invalid observable - using fallback');
              // Identify with basic user data
              window["_chatlio"]?.identify(this.userId, this.fetchUserData?.userData);
              return;
            }
          
          cloudFunctionCall.pipe(
            defaultIfEmpty({}), // CRITICAL FIX: Ensure Observable always emits a value, preventing "undefined where a stream was expected" errors
            timeout(8000) // Add timeout of 8 seconds for the chatliollmv2 function
          ).subscribe({
            next: (response) => {
              // Defensive check: ensure response is valid before accessing properties
              if (response && typeof response === 'object' && response?.status === "success" && response?.data) {
                const finalPayload = this.buildFinalChatlioPayload(
                  userChatlioData,
                  response?.data
                );
                window["_chatlio"]?.identify(this.userId, finalPayload);
              } else {
                // Fallback to basic user data if response is invalid or incomplete
                window["_chatlio"]?.identify(this.userId, this.fetchUserData?.userData);
              }
            },
            error: (err) => {
              // On error or timeout, identify with basic user data
              window["_chatlio"]?.identify(this.userId, this.fetchUserData?.userData);
              this.authService.errorHandlerLogs('Error calling chatliollmv2:', err);
            }
          });
        }
      },
      error: (err) => {
        // On error, still try to identify with whatever data we have
        this.authService.errorHandlerLogs('Error calling getUserDataforChatlio:', err);
      },
    });
  },1500);

    // Call userDetailsForLiveChat asynchronously in the background
    // This should not block the Chatlio widget initialization
    const isChatlioReady = localStorage.getItem("isChatlioReady");
    if (isChatlioReady) {
      // Defer this call to run in the background
      setTimeout(() => {
        (async () => {
          try {
            await this.authService.userDetailsForLiveChat();
          } catch (error) {
            this.authService.errorHandlerLogs('Error calling userDetailsForLiveChat:', error);
          }
        })();
      }, 0); // No delay needed - run asynchronously immediately
    }
  }

  private buildFinalChatlioPayload(
    baseUserData: Data,
    cfData?: Data
  ): Data {
    const payload = {
      ...(baseUserData || {}) // always include base user data
    };
  
    if (cfData) {
      const snapshot = this.buildChatlioSummary(cfData);
      Object.assign(payload, snapshot);
    }
  
    return payload;
  }
  

  private buildChatlioSummary(data: Data): Record<string, string> {
    let lines: string[] = [];
  
    // Case 1: "Key Points" array format
    if (Array.isArray(data?.["Key Points"])) {
      lines = data["Key Points"];
    }
  
    // Case 2: "Customer Snapshot" object format
    else if (
      data?.["Customer Snapshot"] &&
      typeof data["Customer Snapshot"] === "object"
    ) {
      lines = Object.values(data["Customer Snapshot"]) as string[];
    }
  
    // Final bundled payload
    return {
      customer_snapshot: lines.length
        ? lines.map(line => `• ${line}`).join("\n")
        : "No customer data available"
    };
  }
  
}